export const damageCostsSection = {
  label: "Schadenkosten",
  description: "Bitte tragen Sie die verschiedenen Schadenkosten ein.",
  children: [
    {
      control: "claim_costs_editor",
      name: "costs",
      cols: 12,
    },
  ],
};
